<h3> Chargement {{nb}} sur {{total}}</h3>
<div>
  <mat-progress-bar mode="determinate" [value]="pourcent"></mat-progress-bar>
</div>
